import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import images from '../../../Utils/images'
import { useNavigate, useParams } from 'react-router-dom'
import colors from '../../../Utils/colors';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import ImportSettingsModal from '../Components/ImportSettingsModal';
import { IoMdSettings } from "react-icons/io";
import CheerioButton from '../../../Components/CheerioButton';
import ReactFlow, {
    useEdgesState,
    useNodesState,
} from 'reactflow';
import 'reactflow/dist/style.css';
import Helper from '../../../Utils/Helper';
import AddaStepNode from '../Nodes/AddaStepNode';
import { v4 as uuidv4 } from 'uuid';
import AddStepModal from '../Components/AddStepModal';
import SequenceFlow from '../Components/SequenceFlow';
import { useSelector } from 'react-redux';
import { contactlabellistWithoutCountAPI, createEmptySequence, getSequenceDetailsByID, sendSequenceAnnouncement, sendSequenceTest, updateSequence, verifyEmailSequences, getVerificationStats } from '../../../Services';
import { toast } from 'react-toastify';
import CampaignSetup from '../Components/CampaignSetup';
import CampaignReviewSend from '../Components/CampaignReviewSend';
import VerifyEmailModal from '../Components/VerifyEmailModal';
import RunTestModal from '../Components/RunTestModal';
import { eventsend } from '../../../Config/analyticsFunctions';
import VerificationSuccessModal from '../Components/VerificationSuccessModal';
import ToastModal from '../Components/ToastModal';

const getId = () => uuidv4();


const CreateSequence = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const [existingData, setExistingData] = useState();
    const [campaignName, setCampaignName] = useState('');
    const [receiveOn, setReceiveOn] = useState('');
    const [activeStep, setActiveStep] = useState(0);
    const [isISModalOpen, setIsISModalOpen] = useState(false);
    const [verifyEmail, setVerifyEmail] = useState(false);
    const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false);
    const [isVSModalOpen, setIsVSModalOpen] = useState(false);
    const [labelList, setLabelList] = useState();
    const [selectedLabel, setSelectedLabel] = useState();
    const [taskName, setTaskName] = useState('');
    const [nodes, setNodes, onNodesChange] = useNodesState([
        {
            id: getId(),
            type: 'addStepNode',
            position: { x: 0, y: 0 }
        }
    ])
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    const [selectedSenderID, setSelectedSenderID] = useState([])
    const [testEmail, setTestEmail] = useState('');
    const [isRTModalOpen, setIsRTModalOpen] = useState(false);
    const [sequenceID, setSequenceID] = useState('');
    const [status, setStatus] = useState('');
    const [verificationData, setVerificationData] = useState();
    const [isToastOpen, setIsToastOpen] = useState(false);
    const [VStatus, setVStatus] = useState()
    const auth_token = useSelector((state) => state.main.auth_token);
    const [emailsForverification, setemailsForverification] = useState([])
    useEffect(() => {
        if (id) {
            console.log("yessss ", id);
            getSequenceDetailsByIDAPIcall(id);
        }
        // setIsISModalOpen(true);
        getlabellistapicall();
    }, [])

    // useEffect(()=>{
    //     if(selectedLabel?._id && (status !== 'Draft' || !status)){
    //         setIsISModalOpen(true);
    //     }
    // },[selectedLabel])

    useEffect(() => {
        if (existingData) {
            setCampaignName(existingData?.campaignName);
            setReceiveOn(existingData?.setting?.replyTo);
            setNodes(existingData?.frontend?.nodes);
            setEdges(existingData?.frontend?.edges);
            setSelectedSenderID(existingData?.senderIds);
            setSequenceID(existingData?._id);
            setStatus(existingData?.status);
        }
    }, [existingData])

    useEffect(() => {
        if (existingData && labelList) {
            setSelectedLabel(labelList.filter((item) => item?._id === existingData?.labelId)[0])
        }
    }, [existingData, labelList])

    const getSequenceDetailsByIDAPIcall = (_id) => {
        let token = auth_token;
        let data = {
            _id: _id,
        };
        getSequenceDetailsByID(data, token).then((res) => {
            if (res?.flag) {
                setExistingData(res?.data);
                console.log("success ---> ", res)
            } else {
                console.log("failure ---> ", res)
            }
        })
    }

    const steps = [
        'Audience',
        'Create Sequence',
        'Campaign Setup',
        'Review & Publish'
    ];

    const getlabellistapicall = () => {
        let token = auth_token;
        contactlabellistWithoutCountAPI(token).then((res) => {
            if (res?.flag) {
                setLabelList(res.data.v1.filter((item) => {
                    return !(
                        item?.label_name.includes('abandoned-cart-on') ||
                        item?.label_name.includes('orders-feedback-on') ||
                        item?.label_name.includes('orders-cancelled-on') ||
                        item?.label_name.includes('Workflows -') ||
                        item?.label_name.includes('Workflows-') ||
                        item?.label_name.includes('WhatsApp Contacts who') ||
                        item?.label_name.includes('orders-fulfilled-on') ||
                        item?.label_name.includes('orders-placed-on') ||
                        item?.label_name.includes('cod-confirmation-on')
                    )
                }));
            } else {
                toast.error('Unable to fetch labels list, please try again later', { position: 'top-right', autoClose: true })
            }
        });
    };

    const startSequenceAction = (type) => {
        if (sequenceID) {
            if (type === 'draft') {
                const toastId = toast.loading("Preparing to save draft...");
                updateSequenceAction(sequenceID, type, toastId);
            } else {
                const toastId = toast.loading("Preparing to send announcement...");
                if (type === 'test') {
                    sendSequenceTestAction(sequenceID, toastId);
                } else if (type === 'announcement') {
                    if (status === 'Draft') {
                        updateSequenceAction(sequenceID, type, toastId);
                    } else {
                        sendSequenceAnnouncementAction(sequenceID, toastId);
                    }
                }
            }
        } else {
            createSequenceAction(type)
        }
    }

    const createSequenceAction = (type) => {
        const toastId = toast.loading("Creating Sequence...", { position: 'top-right', autoClose: true })
        let token = auth_token;
        let data = {
            campaignName: campaignName,
        };
        createEmptySequence(data, token).then((res) => {
            if (res?.flag) {
                setSequenceID(res?.data?._id)
                toast.update(toastId, {
                    render: 'Sequence created successfully. Updating sequence...',
                    type: toast.TYPE.INFO,
                    isLoading: true,
                    position: 'top-right',
                    autoClose: true,
                    closeButton: true,
                })
                updateSequenceAction(res?.data?._id, type, toastId)
                console.log('sequence created ---> ', res)
            } else {
                toast.update(toastId, {
                    render: 'Sequence creation failed.',
                    type: toast.TYPE.ERROR,
                    isLoading: false,
                    position: 'top-right',
                    autoClose: 2000,
                    closeButton: true,
                })
                console.log('sequence creation failed ---> ', res)
            }
        })
    }

    const updateSequenceAction = (_id, type, toastId) => {
        let token = auth_token;
        let data = {
            setting: {
                replyTo: receiveOn,
            },
            campaignSchedule: {
                days: []
            },
            campaignName: campaignName,
            status: type === 'draft' ? 'Draft' : 'Active',
            senderIds: selectedSenderID,
            frontend: {
                nodes: nodes,
                edges: edges,
            },
            labelId: selectedLabel?._id,
        }
        updateSequence(data, token, _id).then((res) => {
            if (res?.flag) {
                if (type === 'draft') {
                    toast.update(toastId, {
                        render: "Sequence draft saved successfully!",
                        type: toast.TYPE.SUCCESS,
                        isLoading: false,
                        autoClose: 2000,
                        position: 'top-right',
                        closeButton: true,
                    });
                    setTimeout(() => {
                        navigate('/creator/sequences');
                    }, 2500);
                } else {
                    toast.update(toastId, {
                        render: "Sequence updated successfully. Preparing to send...",
                        type: toast.TYPE.INFO,
                        isLoading: true,
                        autoClose: false,
                        position: 'top-right',
                        closeButton: true,
                    })
                    console.log("successfully created sequence --- ", res)
                    if (type === 'announcement') {
                        sendSequenceAnnouncementAction(_id, toastId);
                    } else if (type === 'test') {
                        sendSequenceTestAction(_id, toastId);
                    }
                }
            } else {
                toast.update(toastId, {
                    render: "Error updating sequence.",
                    type: toast.TYPE.ERROR,
                    isLoading: false,
                    autoClose: 2000,
                    position: 'top-right',
                    closeButton: true,
                })
                console.log("error in creating sequence ", res);
            }
        })
    }

    const sendSequenceAnnouncementAction = (_id, toastId) => {
        let token = auth_token;
        let data = {
            _id: sequenceID ? sequenceID : _id,
        }
        sendSequenceAnnouncement(data, token).then((res) => {
            if (res?.flag) {
                toast.update(toastId, {
                    render: "Sequence Announcement sent successfully!",
                    type: toast.TYPE.SUCCESS,
                    isLoading: false,
                    autoClose: 2000,
                    position: 'top-right',
                    closeButton: true,
                })
                setTimeout(() => {
                    navigate('/creator/sequences');
                }, 2500);
                console.log("success started announcement ", res);
            } else {
                toast.update(toastId, {
                    render: "Failed to send announcement.",
                    type: toast.TYPE.ERROR,
                    isLoading: false,
                    autoClose: 2000,
                    position: 'top-right',
                    closeButton: true,
                })
                console.log("failed to send announcement ", res)
            }
        })
    }

    const sendSequenceTestAction = (_id, toastId) => {
        let token = auth_token;
        let data = {
            campaignId: sequenceID ? sequenceID : _id,
            toEmail: testEmail
        }
        sendSequenceTest(data, token).then((res) => {
            if (res?.flag) {
                toast.update(toastId, {
                    render: "Test sent successfully!",
                    type: toast.TYPE.SUCCESS,
                    isLoading: false,
                    autoClose: 2000,
                    position: 'top-right',
                    closeButton: true,
                })
                console.log("res -- ", res);
            } else {
                toast.update(toastId, {
                    render: "Test failed to send.",
                    type: toast.TYPE.ERROR,
                    isLoading: false,
                    autoClose: 2000,
                    position: 'top-right',
                    closeButton: true,
                })
                console.log("res failed ", res)
            }
        })
    }

    const checkStatus = () => {
        let token = auth_token;
        let data = {
            emailArray: emailsForverification,
            taskName: taskName,
            labelId: selectedLabel?._id,
        };
        verifyEmailSequences(data, token).then((res) => {
            if (res?.flag) {
                setVStatus(res?.data?.status);
                if (res?.data?.status === 'Complete') {
                    setVerificationData(res?.data);
                }
            } else {
                toast.error('Email verification failed, please try again later', { autoClose: true, position: 'top-right' });
                setTimeout(() => {
                    setIsVerifyModalOpen(false);
                    setActiveStep(1)
                }, 2000);
            }
        })
    }

    useEffect(() => {
        if (VStatus) {
            let interval;
            if (VStatus === 'Pending') {
                interval = setInterval(() => {
                    checkStatus();
                }, 30000); // 30 seconds interval
            }

            if (VStatus === 'Complete') {
                clearInterval(interval);
            }

            return () => clearInterval(interval);
        }
    }, [VStatus]);

    useEffect(() => {
        if (VStatus === 'Complete' && verificationData && activeStep === 0) {
            setIsVerifyModalOpen(false);
            setIsVSModalOpen(true);
        } else if (VStatus && activeStep !== 0) {
            setIsToastOpen(true);
        }
    }, [VStatus, verificationData])

    // useEffect(()=>{
    //     if(activeStep === 1){
    //         setIsToastOpen(true)
    //     }
    // },[activeStep])

    return (
        <>
            <div className='Column justify-content-start align-items-center w-100 h-100' style={{
                overflow: 'hidden',
            }}>
                {isISModalOpen &&
                    <ImportSettingsModal
                        setIsImportSettingsModalOpen={setIsISModalOpen}
                        verifyEmail={verifyEmail}
                        setVerifyEmail={setVerifyEmail}
                        selectedLabel={selectedLabel}
                        setActiveStep={setActiveStep}
                        setIsVerifyModalOpen={setIsVerifyModalOpen}
                        // setIsVSModalOpen= {setIsVSModalOpen}
                        emailsForverification={emailsForverification}
                        setemailsForverification={setemailsForverification}
                        setTaskName={setTaskName}
                        taskName={taskName}
                    />
                }
                {isRTModalOpen &&
                    <RunTestModal
                        setIsModalOpen={setIsRTModalOpen}
                        testEmail={testEmail}
                        setTestEmail={setTestEmail}
                        onclickruntestaction={() => {
                            startSequenceAction('test');
                        }}
                    />
                }
                {isVSModalOpen &&
                    <VerificationSuccessModal
                        setIsVSModalOpen={setIsVSModalOpen}
                        verificationData={verificationData}
                        setActiveStep={setActiveStep}
                        activeStep={activeStep}
                    />
                }
                {isToastOpen &&
                    <ToastModal
                        status={VStatus}
                        refreshStatusAction={checkStatus}
                        openVSModalAction={() => { setIsVSModalOpen(true) }}
                        setIsToastOpen={setIsToastOpen}
                    />
                }
                <div className='Column justify-content-start align-items-center w-100' style={{
                    paddingBlock: 24,
                    paddingInline: 30,
                    borderBottom: `1px solid ${colors.borderwhite}`,
                    backgroundColor: colors.white01,
                }}>
                    <div className='Row justify-content-start w-100 mb-2'>
                        <img
                            src={images.BackArrowBlack}
                            style={{ height: 24, width: 24, objectFit: 'contain', cursor: 'pointer', marginInlineEnd: 16 }}
                            onClick={() => {
                                if (activeStep) {
                                    setActiveStep(activeStep - 1)
                                } else {
                                    navigate(-1)
                                }
                            }}
                        />
                        <h3 style={{ fontSize: 24, fontWeight: 700 }} onClick={() => {
                            console.log("999999 nodes ", nodes)
                            console.log("999999 edges ", edges)
                        }}>
                            {'Create a new sequence'}
                        </h3>
                    </div>
                    <div className='Row justify-content-between w-100 my-2'>
                        <InputGroup className="mb-2" style={{ width: '30%', marginInlineEnd: 20 }}>
                            {/* <Form.Label style={{ fontSize: 16, fontWeight: 600, color: colors.black }}>
                        {'Messages per day'}
                    </Form.Label> */}
                            <Form.Control
                                type="text"
                                placeholder='Campaign Name'
                                className="w-100 btncustom"
                                style={{ borderRadius: 8 }}
                                value={campaignName}
                                onChange={(e) => {
                                    setCampaignName(e.target.value);
                                }}
                            />
                        </InputGroup>
                        <div style={{ flex: 1, marginInline: 20 }}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </div>
                    </div>
                </div>

                {activeStep === Number(0) &&
                    <>
                        <div className='Column justify-content-center w-100' style={{ flex: 1, paddingBlock: 30 }}>
                            {isVerifyModalOpen &&
                                <VerifyEmailModal
                                    labelId={selectedLabel?._id}
                                    onclickproceedaction={() => {
                                        setActiveStep(1);
                                        setIsVerifyModalOpen(false);
                                    }}
                                    checkStatus={checkStatus}
                                    status={VStatus}
                                />
                            }
                            { }
                            <div className='Column justify-content-start' style={{
                                width: 450,
                                maxHeight: '100%',
                                overflow: 'hidden',
                                backgroundColor: colors.white01,
                                borderRadius: 16,
                                paddingBlock: 24,
                                paddingInline: 30,
                                border: `1px solid ${colors.borderwhite}`
                            }}>

                                <div className='Row justify-content-between w-100'>
                                    <h4 style={{ fontSize: 16, fontWeight: 600 }}>
                                        {'Select audience segment'}
                                    </h4>
                                    <IoMdSettings
                                        size={18}
                                        style={{ cursor: 'pointer', objectFit: 'contain' }}
                                        onClick={() => {
                                            if (selectedLabel?._id) {
                                                setIsISModalOpen(true)
                                            } else {
                                                toast.error('Select label to proceed', { autoClose: true, position: 'top-right' })
                                            }
                                        }}
                                    />
                                </div>
                                <div className='Column justify-content-start w-100' style={{ marginBlock: 24 }}>
                                    <h4 style={{ fontSize: 16, fontWeight: 400, width: '100%' }}>
                                        {'Select Existing Label'}
                                    </h4>
                                    <Form.Select
                                        type="text"
                                        placeholder="Select label"
                                        className="btncustom dropdown mt-2"
                                        style={{ borderRadius: 8, fontSize: 16, fontWeight: 400 }}
                                        value={selectedLabel?._id}
                                        onChange={(e) => {
                                            eventsend("select-label_sequences_selected");
                                            setSelectedLabel(labelList.filter((item) => item?._id === e.target.value)[0]);
                                        }}
                                    >
                                        <option
                                            style={{ width: '100%', marginBlock: 4, borderRadius: 8 }}
                                            key="blankchoice"
                                            hidden
                                            value
                                        >
                                            {'Select label'}
                                        </option>
                                        {labelList &&
                                            labelList.map((e) => {
                                                const displayText = e.label_name.length > 30 ? e.label_name.substring(0, 30) + '...' : e.label_name;
                                                return (
                                                    <option
                                                        style={{
                                                            width: '100%',
                                                            marginBlock: 4,
                                                            borderRadius: 8,
                                                        }}
                                                        value={e._id}
                                                        key={e._id}
                                                        title={e.label_name}
                                                    >
                                                        {displayText}
                                                    </option>
                                                );
                                            })}
                                    </Form.Select>
                                </div>

                                {/* <div className='Column justify-content-start w-100' style={{marginBlock:24}}>
                    <h4 style={{fontSize:16,fontWeight:600}}>
                        {'OR'}
                    </h4>
                </div>
                <div className='Column justify-content-start w-100' style={{marginBlock:24}}>
                    <h4 style={{fontSize:16,fontWeight:400,width:'100%'}}>
                        {'Upload a new list'}
                    </h4>
                    <div className='mt-2 Row justify-content-center w-100' style={{
                        border:`2px dashed ${colors.borderwhite}`,
                        paddingBlock:40,
                        paddingInline:30,
                        borderRadius:16
                    }}>
                        <img 
                            src={images.ImgUpIcon} 
                            style={{height:40,width:60,objectFit:'contain'}}
                        ></img>
                        <p className='mx-2'>
                            {'Drag & drop file here/ upload'}
                        </p>
                    </div>
                </div> */}
                                <CheerioButton
                                    btnText={'Next'}
                                    textStyle={{ color: colors.white01 }}
                                    backColor={colors.primary03}
                                    borderStyle={{ borderColor: colors.primary03, width: '100%' }}
                                    onclick={() => {
                                        // if(verifyEmail){
                                        //     setIsVerifyModalOpen(true);
                                        // }else{
                                        //     setActiveStep(1)
                                        // }
                                        setIsISModalOpen(true)
                                    }
                                    }
                                    disabled={selectedLabel ? false : true}
                                />
                            </div>
                        </div>
                    </>
                }

                {activeStep === Number(1) &&
                    <>
                        <div className='Row justify-content-center w-100' style={{
                            flex: 1,
                        }}>
                            <SequenceFlow
                                setActiveStep={setActiveStep}
                                nodes={nodes}
                                setNodes={setNodes}
                                onNodesChange={onNodesChange}
                                edges={edges}
                                setEdges={setEdges}
                                onEdgesChange={onEdgesChange}
                                activeStep={activeStep}
                            />
                        </div>
                    </>
                }

                {activeStep === Number(2) &&
                    <>
                        <div className='Column justify-content-center align-items-center w-100' style={{
                            flex: 1,
                        }}>
                            <CampaignSetup
                                setActiveStep={setActiveStep}
                                campaignName={campaignName}
                                setCampaignName={setCampaignName}
                                receiveOn={receiveOn}
                                setReceiveOn={setReceiveOn}
                                selectedSenderID={selectedSenderID}
                                setSelectedSenderID={setSelectedSenderID}
                            />
                        </div>
                    </>
                }

                {activeStep === Number(3) &&
                    <>
                        <div className='Row justify-content-center w-100' style={{
                            flex: 1,
                        }}>
                            <SequenceFlow
                                setActiveStep={setActiveStep}
                                nodes={nodes}
                                setNodes={setNodes}
                                onNodesChange={onNodesChange}
                                edges={edges}
                                setEdges={setEdges}
                                onEdgesChange={onEdgesChange}
                                review={true}
                                selectedLabel={selectedLabel}
                                onclickruntestaction={() => { setIsRTModalOpen(true) }}
                                onclickstartsequenceaction={() => {
                                    startSequenceAction('announcement');
                                }}
                                onclicksavedraftaction={() => {
                                    startSequenceAction('draft');
                                }}
                            />
                            {/* <CampaignReviewSend selectedLabel={selectedLabel} /> */}
                        </div>
                    </>
                }

            </div>
        </>
    )
}

export default CreateSequence